<template>
    <div class="pp-lottery-winnings">
        <DsDropdown v-model="selectedOption" :options="options" id="winnings-dropdown" />

        <div v-if="!isSubgameSelected" class="pp-lottery-winnings__description">
            Výše výherního násobku závisí na tom, kolik čísel bylo nutné vylosovat, než padla ta vaše. Proto čím nižší
            číslo je ve sloupci Počet čísel, tím vyšší je výherní násobek.
        </div>

        <DsTable>
            <DsRow v-if="!isSubgameSelected">
                <DsCell type="th">Pořadí</DsCell>
                <DsCell type="th">Počet čísel</DsCell>
                <DsCell type="th">Výherní násobek</DsCell>
            </DsRow>
            <template v-if="!isSubgameSelected">
                <DsRow v-for="(order, index) in winningOrdersGrid[selectedOption]" :key="index">
                    <DsCell>{{ index + 1 }}. pořadí</DsCell>
                    <DsCell>{{ order[0] }}</DsCell>
                    <DsCell><strong v-html="formatMultiple(order[1] as number)"></strong></DsCell>
                </DsRow>
            </template>
            <template v-else>
                <DsRow v-for="(order, index) in winningOrdersGrid[selectedOption]" :key="index">
                    <DsCell class="pp-r6-subgame" type="th">{{ order[0] }}</DsCell>
                    <DsCell class="pp-r6-subgame"><strong>2x</strong></DsCell>
                </DsRow>
            </template>
        </DsTable>
    </div>
</template>
<script lang="ts" setup>
import { computed, ref } from "vue";
import { StringUtils } from "@sazka/utils/string-utils";
import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import DsCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";
import DsDropdown from "@sazka/design-system/src/forms/components/ds-dropdown.vue";
import { DsDropdownItemModel } from "@sazka/design-system/src/forms/components/ds-dropdown/ds-dropdown-models";
import { PpDraw } from "@/lotteries/services/model/draw";

const options: DsDropdownItemModel[] = [
    { value: 0, label: "SÁZKA ZA 10 KČ AŽ 100 KČ" },
    { value: 1, label: "HLAVNÍ HRA ZA 200 KČ AŽ 500 KČ" },
    { value: 2, label: "SUDÁ, NEBO LICHÁ" },
    { value: 3, label: "NÍZKÁ, NEBO VYSOKÁ" },
];

defineProps<{
    // Prevents [object-object] from being in DOM
    results: PpDraw;
}>();

const selectedOption = ref(0);
const isSubgameSelected = computed(() => selectedOption.value >= 2);

const winningOrdersGrid = [
    [
        [6, 10_000],
        [9, 250],
        [12, 50],
        [15, 5],
        [18, 3],
        [21, 1],
    ],
    [
        [6, 12_500],
        [9, 250],
        [12, 50],
        [15, 5],
        [18, 3],
        [21, 1],
    ],
    [["Převaha sudých čísel"], ["Stejný počet"], ["Převaha lichých čísel"]],
    [["Převaha nízkých čísel"], ["Stejný počet"], ["Převaha vysokých čísel"]],
];

const formatMultiple = (multiple: number) => `${StringUtils.formatNumber(multiple)}x`;
</script>
